import React from 'react';
import modalManager from '../../services/modalManager';

export default function RemoveCorDialog({onConfirm, onCancel, cor}) {
  return (
    <div className="modal fade" id="removeCorDialog" role="dialog" data-backdrop="static">
      <div className="modal-dialog modal-small" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Remover Cor</h5>
            <button type="button" className="close" onClick={modalManager.hide}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            Deseja remover a cor {cor.codigo} da pasta? Você ainda precisará salvar o formulário para concretizar a operação.
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancelar</button>
            <button type="button" className="btn btn-danger" onClick={onConfirm}>Remover</button>
          </div>
        </div>
      </div>
    </div>
  );
}